import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';

const generatePayTransactionItem = (rId, dayType, tourStartTime) => {
    let id;
    let title;
    let itemStyle = getItemStyles('pay-transaction');
    const { rdtId, tour } = dayType;
    if (typeof(dayType.tour.tourPayTransactions[0]) === 'object') {
        if (tour.tourPayTransactions.length === 1) {
            title = tour.tourPayTransactions[0].code;
        } else {
            title = tour.tourPayTransactions[0].code + ' (...)';
        }
    } else {
        if (tour.tourPayTransactions.length === 1) {
            title = tour.tourPayTransactions;
        } else {
            title = tour.tourPayTransactions[0] + ' (...)';
        }
    }

    const payTransactionItem = {
        id: `payTransaction-${tour.tourId}`,
        rdtId,
        itemType: 'pay-transaction',
        start_time: moment(tourStartTime).startOf('day'),
        end_time: moment(tourStartTime).endOf('day'),
        title,
        group: rId,
        backgroundColor: tour.isApproved ? "gray" : itemStyle.backgroundColor,
        color: itemStyle.color,
        borderStyle: itemStyle.borderStyle,
        borderColor: itemStyle.borderColor
    };

    return payTransactionItem;
}

export default generatePayTransactionItem;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generate-timeline/generatePayTransactionItem.js